import { RecordBase } from '../../providers/request/record-base.model';
import { OrganizationType } from './organization-type.enum';

export class OrganizationMember extends RecordBase {
  projectId?: number;
  organizationName?: string;
  organizationId?: number;
  organizationType?: OrganizationType;
  sectionId?: number;
  memberId?: number;
  memberName?: string;
  departmentId?: number;
  departmentName?: string;
  postId?: number;
  postName?: string;
  userId?: number;
  userName?: string;
  main?: boolean = false;
  sortOrder?: number;
  comment?: string;
  // 前端自用
  orgUnitCascaderValue: any[] = [];
  dpuValue: number[] = [];
  sectionType?: OrganizationType;
}
